import { Messages } from '../../../codegen/Localize';
import { BackgroundJobTaskType } from '../../models/BackgroundJobInfo';

export interface IBackgroundJobExtendedInfo {
  luid: string; //luid of the background job
  taskType: keyof typeof BackgroundJobTaskType | undefined; // see BackgroundJobTaskType for more info
  projectName: string | undefined; // the project name that the content belongs to
  scheduleName: string | undefined; // the schedule name that the task is related to
  contentName: string | undefined; // the name of the content
  associatedUserName: string | undefined; // the user name that owns the content
  siteName: string | undefined; // the name of the site
}

export function getBackgroundJobExtendedInfoDialog(extendedInfo: IBackgroundJobExtendedInfo, isServerPage: boolean): string[] {
  const result = [];

  // LUID
  const luid = Messages.backgroundJobsExtendedInfoLuid({
    LUID: extendedInfo.luid,
  });
  result.push(luid);

  // Project
  if (extendedInfo.projectName) {
    const project = Messages.backgroundJobsExtendedInfoProject({
      PROJECT_NAME: extendedInfo.projectName,
    });
    result.push(project);
  }

  // Schedule
  if (extendedInfo.scheduleName) {
    const schedule = Messages.backgroundJobsExtendedInfoSchedule({
      SCHEDULE_NAME: extendedInfo.scheduleName,
    });
    result.push(schedule);
  }

  // Content Name
  if (extendedInfo.contentName) {
    const contentName = Messages.backgroundJobsExtendedInfoContent({
      CONTENT_NAME: extendedInfo.contentName,
    });
    result.push(contentName);
  }

  // Associated User
  if (extendedInfo.associatedUserName) {
    const associatedUser = Messages.backgroundJobsExtendedInfoAssociatedUser({
      ASSSOCIATED_USER_NAME: extendedInfo.associatedUserName,
    });
    result.push(associatedUser);
  }

  // Site ID
  if (isServerPage && extendedInfo.siteName) {
    const site = Messages.backgroundJobsExtendedInfoSite({
      SITE_NAME: extendedInfo.siteName,
    });
    result.push(site);
  }

  return result;
}
